export default __webpack_public_path__ + "static/rob-desktop-ec4ecf1c8d378fa6d77bd885bfaa2446.webp";